var heading_default = {
  "fontElementMap": "_7bq5v",
  "elementSpacing": "scQlf",
  "headerOne": "-iqQG scQlf",
  "headerTwo": "_7d6qt scQlf",
  "headerThree": "jZpvm scQlf",
  "headerFour": "UQERr scQlf",
  "headerFive": "N9vD9 scQlf",
  "headerSix": "-ms1a scQlf",
  "child": "hpUmk"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
